import {PaginaLogada} from "../../componentes";
import {useEffect, useMemo, useState} from "react";
import {CirastServico} from "../../servicos";
import {exibirMensagemErro, exibirMensagemSucesso} from "../../util";
import {Clinica} from "../../tipos/clinica";
import {ActionIcon, Badge, Button, Card, Grid, Group, Modal, Text, TextInput, Title, Tooltip} from "@mantine/core";
import {MRT_Localization_PT_BR} from "mantine-react-table/locales/pt-BR";
import {MantineReactTable, MRT_ColumnDef} from "mantine-react-table";
import {IconCircleOff, IconPower, IconSquareRoundedX} from "@tabler/icons-react";
import {useDisclosure, useMediaQuery} from "@mantine/hooks";
import {
  COL_RESP_1,
  COL_RESP_2,
  COL_RESP_3,
  COL_RESP_6,
  COR,
  ICONE,
  IS_MOBILE
} from "../../config/constantes/constantes-mantine";
import {BotaoPesquisar, BotaoSalvar} from "../../componentes/botao/botao-mantine";

export default function CadastrarClinicaCirast() {

  const [isCarregando, setIsCarregando] = useState(false)
  const [clinica, setClinica] = useState<Clinica>(new Clinica())
  const [listaClinicas, setListaClinicas] = useState<Clinica[]>([])
  const [objetoAtivoAlterar, setObjetoAtivoAlterar] = useState<Clinica>(new Clinica())
  const [modalAtivarInativar, {open: openAtivarInativar, close: closeAtivarInativar}] = useDisclosure(false);
  const isMobile = useMediaQuery(IS_MOBILE);


  function carregarCep(e: any) {
    e.preventDefault()
    if (clinica.cep) {
      setIsCarregando(true)
      CirastServico.consultarCep(clinica.cep)
        .then(res => res.json())
        .then(dados => {
          setClinica({
            ...clinica,
            uf: dados.uf,
            bairro: dados.bairro,
            cidade: dados.localidade,
            logradouro: dados.logradouro
          })
          setIsCarregando(false)
        })
        .catch(() => {
          setIsCarregando(false)
          exibirMensagemErro("Erro ao consultar CEP")
        })
      return
    }
    exibirMensagemErro("Um cep precisa ser informado")
  }

  function salvar(e: any) {
    e.preventDefault()
    CirastServico.cadastrarClinica(clinica)
      .then(res => res.json())
      .then(dados => {
        exibirMensagemSucesso(`Clinica ${dados.nome} cadastrada com sucesso.`)
        setClinica(new Clinica())
      })
      .catch(() => exibirMensagemErro("Erro ao cadastrar clínica"))
  }

  function ativarInativarClinica() {
    closeAtivarInativar()
    setIsCarregando(true)
    CirastServico.ativarInativar(objetoAtivoAlterar)
      .then(res => res.json())
      .then(dados => {
        exibirMensagemSucesso(`Clínica ${dados.nome} ${dados.ativa ? "ativada" : "inativada"} com sucesso`)
        setObjetoAtivoAlterar(new Clinica())
        buscar()
      })
      .finally(() => setIsCarregando(false))
  }

  function buscar() {
    CirastServico.consultarClinica()
      .then(res => res.json())
      .then(dados => {
        setListaClinicas(dados)
      })
      .catch(() => exibirMensagemErro("Erro ao consultar clínicas"))
  }

  useEffect(() => {
    buscar()
  }, []);

  const colunas = useMemo<MRT_ColumnDef<Clinica>[]>(() => [
      {
        accessorKey: 'nome',
        header: 'NOME',
        filterVariant: 'autocomplete',
      },
      {
        accessorKey: 'cnpj',
        header: 'CNPJ',
      },
      {
        accessorKey: 'logradouro',
        header: 'Logradouro',
      },
      {
        accessorKey: 'ativa',
        header: 'Status',
        Cell: ({cell}) => (
          <Badge color={cell.getValue() ? COR.PRIMARIO : COR.PERIGO}>
            {cell.getValue() ? "Ativa" : "Inativa"}
          </Badge>
        )
      },
    ],
    []
  )

  return (
    <PaginaLogada titulo="Cadastrar Clínica" isCarregando={isCarregando}>
      <Card withBorder shadow="sm" radius="md">
        <Card.Section inheritPadding withBorder py={"md"}><Title order={4}>Dados da clinica</Title></Card.Section>
        <Grid p={"md"}>
          <Grid.Col span={COL_RESP_6}>
            <TextInput
              label={"Nome"}
              placeholder={"Nome da Clínica"}
              value={clinica.nome}
              onChange={(e) => setClinica({...clinica, nome: e.target.value.toUpperCase()})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_3}>
            <TextInput
              label={"CNPJ"}
              placeholder={"CNPJ"}
              value={clinica.cnpj}
              onChange={(e) => setClinica({...clinica, cnpj: e.target.value.toUpperCase()})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_3}>
            <TextInput
              label={"Telefone"}
              placeholder={"Telefone"}
              value={clinica.telefone}
              onChange={(e) => setClinica({...clinica, telefone: e.target.value.toUpperCase()})}
            />
          </Grid.Col>
        </Grid>

        <Grid p={"md"}>
          <Grid.Col span={COL_RESP_2}>
            <TextInput
              label={"CEP"}
              placeholder={"CEP"}
              value={clinica.cep}
              onChange={(e) => setClinica({...clinica, cep: e.target.value.toUpperCase()})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_2} style={{alignSelf: "self-end"}}>
            <BotaoPesquisar onClick={carregarCep}/>
          </Grid.Col>
        </Grid>

        <Grid p={"md"}>
          <Grid.Col span={COL_RESP_3}>
            <TextInput
              label={"Logradouro"}
              placeholder={"Logradouro"}
              value={clinica.logradouro}
              onChange={(e) => setClinica({...clinica, logradouro: e.target.value.toUpperCase()})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_1}>
            <TextInput
              label={"Número"}
              placeholder={"Número"}
              value={clinica.numero}
              onChange={(e) => setClinica({...clinica, numero: e.target.value.toUpperCase()})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_2}>
            <TextInput
              label={"Bairro"}
              placeholder={"Bairro"}
              value={clinica.bairro}
              onChange={(e) => setClinica({...clinica, bairro: e.target.value.toUpperCase()})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_3}>
            <TextInput
              label={"Cidade"}
              placeholder={"Cidade"}
              value={clinica.cidade}
              onChange={(e) => setClinica({...clinica, cidade: e.target.value.toUpperCase()})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_3}>
            <TextInput
              label={"Complemento"}
              placeholder={"Complemento"}
              value={clinica.complemento}
              onChange={(e) => setClinica({...clinica, complemento: e.target.value.toUpperCase()})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_2}>
            <TextInput
              label={"UF"}
              placeholder={"UF"}
              value={clinica.uf}
              onChange={(e) => setClinica({...clinica, uf: e.target.value.toUpperCase()})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_2} style={{alignSelf: "self-end"}}>
            <BotaoSalvar onClick={salvar}/>
          </Grid.Col>
        </Grid>
      </Card>

      <Card withBorder shadow="sm" radius="md" mt={30}>
        <Title my={20} order={3}>Clinicas Cadastradas</Title>
        <MantineReactTable
          data={listaClinicas}
          columns={colunas}
          enablePagination
          enableFacetedValues={true}
          initialState={{showColumnFilters: true}}
          localization={MRT_Localization_PT_BR}
          enableRowActions={true}
          positionActionsColumn='last'
          renderRowActions={
            ({row}) => (
              <Group wrap="nowrap" gap="lg">
                {/*<Tooltip label="Alterar">*/}
                {/*  <ActionIcon*/}
                {/*      aria-label="Alterar"*/}
                {/*      color={BOTAO.COR.ALERTA}*/}
                {/*      onClick={() => {*/}
                {/*        setObjeto(row.original)*/}
                {/*        setAlterarObj(true)*/}
                {/*      }}*/}
                {/*  >*/}
                {/*    <IconPencil />*/}
                {/*  </ActionIcon>*/}
                {/*</Tooltip>*/}

                <Tooltip label={row.original.ativa ? "Inativar" : "Ativar"}>
                  <ActionIcon
                    aria-label="Inativar"
                    color={row.original.ativa ? "red" : "blue"}
                    onClick={() => {
                      setObjetoAtivoAlterar(row.original)
                      openAtivarInativar()
                    }}
                  >
                    {row.original.ativa ? <IconCircleOff/> : <IconPower/>}
                  </ActionIcon>
                </Tooltip>
              </Group>
            )
          }
        />
      </Card>

      <Modal opened={modalAtivarInativar}
             onClose={closeAtivarInativar}
             fullScreen={isMobile}
             centered
             overlayProps={{
               backgroundOpacity: 0.55,
               blur: 3,
             }}
             title={
               <>
                 Tem certeza que deseja
                 <Text fw={700} component="span" c={objetoAtivoAlterar.ativa ? COR.PERIGO : COR.PRIMARIO}>
                   {objetoAtivoAlterar.ativa ? " INATIVAR " : " ATIVAR "}
                 </Text> esta clínica?
               </>}
      >
        <Group justify="center" gap="xl">
          <Button
            color={objetoAtivoAlterar.ativa ? COR.PERIGO : COR.PRIMARIO}
            leftSection={objetoAtivoAlterar.ativa ? <ICONE.INATIVAR/> : <ICONE.ATIVAR/>}
            onClick={ativarInativarClinica}>
            {objetoAtivoAlterar.ativa ? " Inativar " : " Ativar "}</Button>
          <Button color={COR.SECUNDARIO} leftSection={<IconSquareRoundedX/>}
                  onClick={closeAtivarInativar}>Cancelar</Button>
        </Group>
      </Modal>
    </PaginaLogada>
  )
}